<template>
  <div class="h-full overflow-y-scroll">
    <div class="pt-4 px-4">
      <h3 class="text-2xl font-bold">Recolecciones</h3>
    </div>

    <empty v-if="hasLoaded && !loading && recolecciones.length === 0" class="mt-4" :texto="'No hay recolecciones.'" />

    <div v-if="recolecciones.length > 0" class="block sm:hidden mx-4 mt-4">
      <div v-for="recoleccion in recolecciones" :key="recoleccion.id" class="border border-gray-200 rounded mb-4 p-2 bg-white">
        <div class="flex items-center justify-between gap-2">
          <div :class="collectionStatus(recoleccion.estado).style" class="rounded-full text-center py-1 px-2">
            {{ collectionStatus(recoleccion.estado).label }}
          </div>
          <router-link :to="`/admin/recolecciones/${recoleccion.id}`" class="underline font-medium">
            {{ recoleccion.id }}
          </router-link>
        </div>
        <p class="mt-2">{{ recoleccion.proveedor.nombre }}</p>
        <div class="flex justify-between text-sm mt-2">
          <span>{{ formatDate(recoleccion.solicitada_at) }}</span>
          <span>{{ (recoleccion.recoleccion_pedidos || []).length }} órdenes</span>
        </div>
      </div>
    </div>

    <div v-if="recolecciones.length > 0" class="hidden sm:block mx-4 mt-4 border border-gray-200 rounded bg-white">
      <div class="overflow-scroll">
        <table class="w-full text-sm text-left">
          <thead class="text-s border-b border-b-gray-200">
            <tr>
              <th class="py-3 pr-4 pl-4">Estado</th>
              <th class="py-3 pr-4">Recolección</th>
              <th class="py-3 pr-4">Proveedor</th>
              <th class="py-3 pr-4">Fecha</th>
              <th class="py-3 pr-4">Órdenes</th>
            </tr>
          </thead>
          <tbody v-for="recoleccion in recolecciones" :key="recoleccion.id">
            <tr class="text-s border-t">
              <td class="py-3 pr-4 pl-4">
                <div :class="collectionStatus(recoleccion.estado).style" class="rounded-full text-center w-48 py-1 px-2">
                  <p class="whitespace-nowrap">{{ collectionStatus(recoleccion.estado).label }}</p>
                </div>
              </td>
              <td class="py-4 pr-4 font-medium whitespace-nowrap underline">
                <router-link :to="`/admin/recolecciones/${recoleccion.id}`">
                  {{ recoleccion.id }}
                </router-link>
              </td>
              <td class="py-3 pr-6 whitespace-nowrap">{{ recoleccion.proveedor.nombre }}</td>
              <td class="py-3 pr-4 whitespace-nowrap">{{ formatDate(recoleccion.solicitada_at) }}</td>
              <td class="py-3 pr-4">{{ (recoleccion.recoleccion_pedidos || []).length }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useToast } from "vue-toast-notification";
import { store } from "../store.js";
import { utils } from "./utils/utils.js";
import { collectionStatus } from "./utils/recolecciones.js";

export default {
  name: "AdminRecolecciones",
  setup() {
    const recolecciones = ref([]);
    const loading = ref(false);
    const hasLoaded = ref(false);

    async function load() {
      loading.value = true;
      hasLoaded.value = false;
      try {
        recolecciones.value = await utils.getRecolecciones();
        hasLoaded.value = true;
      } catch (error) {
        if (error.status !== 401) {
          useToast().error("No se pudieron cargar las recolecciones", { position: "top-right" });
        }
      } finally {
        loading.value = false;
      }
    }

    function formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("es-MX", { timeZone: "America/Mexico_City" });
    }

    onMounted(() => {
      if (store.authAdmin) load();
    });
    watch(() => store.authAdmin, (authorized) => {
      if (authorized) load();
    });

    return {
      recolecciones,
      loading,
      hasLoaded,
      collectionStatus,
      formatDate,
    };
  },
};
</script>
